















import { Prop, Component, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class SortIcons extends Vue {
  // props
  @Prop() currentSort: string | undefined
  @Prop() currentSortDir: string | undefined
  @Prop() category: string | undefined
}
